import { render, staticRenderFns } from "./PLoading.vue?vue&type=template&id=298cc7d4&"
import script from "./PLoading.vue?vue&type=script&lang=js&"
export * from "./PLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports